import { Context } from "urql";
import { publicConfig } from "../util/public-config";
import { KIWI_PATH } from "./constants";

const checkSubscriberStatusQuery = `
  query CheckSubscriberStatus($guestEmail: String!) {
    checkSubscriberStatus(email: $guestEmail)
  }
  `;

const checkSubscriberExists = async ({ guestEmail }, graphqlClient) => {
  const apiHost = `${publicConfig?.apiHost}`;
  Context.url = `${apiHost}${KIWI_PATH}`;

  try {
    const { data, error } = await graphqlClient
      .query(checkSubscriberStatusQuery, { guestEmail }, Context)
      .toPromise();

    if (error) {
      console.error("GraphQL error:", error.message);
      return true; // do not show welcome offer
    }

    // Assuming the response data structure is: { data: { checkSubscriberStatus: true/false } }
    return data?.checkSubscriberStatus === "true"; // Return true if the subscriber exists
  } catch (error) {
    console.error("Error checking subscriber status:", error.message);
    return true; // do not show welcome offer
  }
};

export default checkSubscriberExists;
